var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { faClose } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect, useRef, useState } from 'react';
import getTranslation from '../../../strings/i18n';
import { RenderIf } from 'syf-component-library/ui/atoms';
import SyfLoader from 'syf-component-library/ui/atoms/Loader/SyfLoader';
import SlideInModalPortal from 'syf-component-library/ui/patterns/SlideInModalPortal/SlideInModalPortal';
import SpendingTrends from '..';
import { getSpendingTrendsAnalyticsProps } from '../../../const/analytics/spending-trends';
import { addColoredBorder, getSpendingTrends } from '../../../helpers/spending-trends';
import useDeviceWidth from '../../../hooks/use-device-width';
import useSpendingTrends from '../../../hooks/use-spending-trends';
import useTriggerAnalyticsEvent from '../../../hooks/use-trigger-analytics-event';
import { StyledCloseButton, StyledPrimaryButton } from '../../../styles/buttons';
import { StyledTitle } from '../../../styles/text';
import { StyledModalActions, StyledModalHeader } from '../../activity/modal/subcomponents';
import GenericError from '../../common/generic-error';
import NetworkErrorIllustration from '../../common/illustrations/network-error';
import { StyledLoaderWrapper } from './subcomponents';
// TODO temporary loader this should be revisited if needed
var SyfStyledLoader = function () { return (_jsx(StyledLoaderWrapper, { alignItems: "center", justifyContent: "center", children: _jsx(SyfLoader, { size: 2 }) })); };
var initialSelectedDate = 'recent';
var SpendingTrendsDrawer = function (_a) {
    var closeDrawer = _a.closeDrawer, isDrawerOpen = _a.isDrawerOpen;
    var t = getTranslation().t;
    var drawerTopRef = useRef(null);
    var isMobile = useDeviceWidth();
    var _b = useState(initialSelectedDate), selectedDate = _b[0], setSelectedDate = _b[1];
    useEffect(function () {
        if (isDrawerOpen) {
            setSelectedDate(initialSelectedDate);
        }
    }, [isDrawerOpen]);
    var _c = useSpendingTrends(isDrawerOpen, selectedDate), data = _c.data, isLoading = _c.isLoading, isError = _c.isError, formattedTotalAmount = _c.formattedTotalAmount;
    var spendings = getSpendingTrends(data);
    var spendingTrendsData = addColoredBorder((spendings === null || spendings === void 0 ? void 0 : spendings.spendingCategories) || []);
    var analyticsProps = getSpendingTrendsAnalyticsProps();
    var getAnalyticsEvent = function () {
        // check 1: error -> check 2: returned data, but no purchases -> check 3: purchases
        if (isError)
            return 'spendingTrends.error';
        if (data && (spendingTrendsData === null || spendingTrendsData === void 0 ? void 0 : spendingTrendsData.length) === 0)
            return 'spendingTrends.noPurchase';
        return 'spendingTrends.view';
    };
    useTriggerAnalyticsEvent(getAnalyticsEvent(), undefined, isDrawerOpen && !isLoading);
    return (_jsx(SlideInModalPortal, { containerId: "mma-spending-trends-drawer-container", id: "spending-trends-drawer", isOpen: isDrawerOpen, escapeModalHandler: closeDrawer, header: _jsxs(StyledModalHeader, { alignItems: "center", justifyContent: "space-between", children: [_jsx(StyledTitle, { children: t('spendingTrends.drawerHeading') }), _jsx(StyledCloseButton, __assign({ onClick: closeDrawer, "aria-label": "close" }, analyticsProps.xButton, { children: _jsx(FontAwesomeIcon, { icon: faClose, size: "1x" }) }))] }), footer: _jsx(StyledModalActions, { justifyContent: "end", alignItems: "center", children: _jsx(StyledPrimaryButton, __assign({ onClick: closeDrawer }, analyticsProps.backToActivity, { children: t('spendingTrends.primaryButton') })) }), children: _jsxs(_Fragment, { children: [_jsx("div", { ref: drawerTopRef }), _jsx(RenderIf, { condition: isLoading, children: _jsx(SyfStyledLoader, {}) }), _jsx(RenderIf, { condition: !isLoading && isError, children: _jsx(GenericError, { image: _jsx(NetworkErrorIllustration, {}), titleKey: "common.apiErrorHeading", subtitleKey: "common.apiErrorMessage" }) }), _jsx(RenderIf, { condition: !isLoading && !isError, children: _jsx(SpendingTrends, { formattedTotalAmount: formattedTotalAmount, isMobile: isMobile, selectedDate: selectedDate, setSelectedDate: setSelectedDate, spendingTrendsData: spendingTrendsData }) })] }) }));
};
export default SpendingTrendsDrawer;
//# sourceMappingURL=index.js.map